import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  declare textValue: string

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const button = this.element.querySelector("button")
      if (button) {
        const original = button.textContent
        button.textContent = "Copied!"
        setTimeout(() => { button.textContent = original }, 2000)
      }
    })
  }
}
